import { pathOr, lensPath, set, map } from 'ramda';
import { compose } from 'recompose';
import { splitTheLocationString } from '../../Configs/autoAnswerConfigurator';
import { checkAndGetAnswerFrmUserInput } from 'src/features/core/ChatEngine/Bot/botServiceUtils/commonFns';

/**
 * mkAPIUpdateableForPathType - this method will update the api resouce data which is of
 *  path type where business and business income is used
 * @param paths paths can be save paths array
 * @param questionId can have question id
 */
export const mkAPIUpdateableForPathType = (_dataBag: any) => {
  let dataBag = _dataBag;

  const {
    filterPathTypeData: paths,
    apiResource: readResource,
    apiData,
    _apiResource,
  } = dataBag;
  let _apiData = apiData;
  const mapSavePath = (path: any) => {
    _apiData = pathOr(_apiData, [readResource], _apiResource);
    const locationToSave = splitTheLocationString(
      pathOr('', ['mapped_for'], path)
    );
    const _getLocationToSaveWithIndexAlterations: any =
      locationToSave &&
      locationToSave.map((location: any) => {
        if (!isNaN(Number(location))) {
          return Number(location);
        }
        return location;
      });

    const updatedAPIData = compose(
      set(
        lensPath(_getLocationToSaveWithIndexAlterations),
        checkAndGetAnswerFrmUserInput(dataBag, path)
      )
    )(_apiData);
    dataBag = compose(
      set(lensPath(['apiData']), updatedAPIData),
      set(lensPath(['_apiResource', readResource]), updatedAPIData),
      set(lensPath(['_apiResourceData', readResource]), updatedAPIData)
    )(dataBag);
    return apiData;
  };
  map(mapSavePath, paths);
  return dataBag;
};
